export const ANALYST_PENDING_ORDERS_FILTER = 'analyst-pending-orders-filter';
export const ANALYST_REVIEW_ORDERS_FILTER = 'analyst-review-orders-filter';
